import { DismissedConflictsStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('ADD_CONFLICT_ID_TO_DISMISS_ID', function addConflictIdToDismissIdMap(conflictId: string, dismissedId: string) {
    DismissedConflictsStore().conflictIdToDismissIdMap.set(conflictId, dismissedId);
});
